/**
 * Bundled Product Tabs Script
 *
 * This script initializes the bundled product tabs functionality.
 * It listens for click events on the product buttons and toggles
 * the active state of the corresponding content blocks.
 *
 * The script is designed to be idempotent, preventing multiple initializations if included more than once on a page.
 */

(function() {
  // Prevent multiple initializations
  if (window.__bundledProductTabsInit) return;
  window.__bundledProductTabsInit = true;

  // Wait for the DOM to be fully loaded before initializing the tabs
  document.addEventListener('DOMContentLoaded', function() {

    // Select all bundled product tab containers & loop
    const productBundledTabs = document.querySelectorAll('.bundled-products-tabs');
    productBundledTabs.forEach(productBundledTab => {
      if (productBundledTab.dataset.tabsInit) return;
      productBundledTab.dataset.tabsInit = 'true';

      // Grab product buttons and blocks
      const productButtons = productBundledTab.querySelectorAll('.bundled-products-tabs__product');
      const shopifyBlocks = productBundledTab.querySelectorAll('.bundled-products-tabs__content .shopify-block');

      // Loop buttons
      productButtons.forEach(button => {
        button.addEventListener('click', function() {

          // Grab product ID
          const productId = this.getAttribute('data-product-id');

          // Early exit if no product ID is found
          if (!productId) return;

          // Remove active class from all buttons
          productButtons.forEach(productButton => productButton.classList.remove('bundled-products-tabs__product--active'));

          // Add active class to the clicked button
          this.classList.add('bundled-products-tabs__product--active');

          // Toggle rich-text active class
          shopifyBlocks.forEach(shopifyBlock => {
            if (shopifyBlock.querySelector('[data-product-id]').getAttribute('data-product-id') === productId) {
              console.log('add active class');
              shopifyBlock.classList.add('shopify-block--active');
            } else {
              shopifyBlock.classList.remove('shopify-block--active');
            }
          });
        });
      });

      // Activate the first tab on load (after listeners are attached)
      if (productButtons[0]) productButtons[0].click();
    });
  });
})();
